/** Drop signed transforms from an image cache key, but keep blur because it changes the image. */
export const normalizeImageKey = (url: string): string => {
	const parsed = new URL(url)
	const blur = parsed.searchParams.get('blur')

	parsed.search = blur ? `?blur=${blur}` : ''

	return parsed.toString()
}
